<div class="main-game-progress-group">
  <div class="played" [ngStyle]="{width: progressValue + '%'}"></div>
  <div class="current" [ngStyle]="{left: progressValue + '%'}"></div>
  <div class="unplayed" [ngStyle]="{width: (100 - progressValue) + '%'}"></div>
  <div class="percentage">{{progressValue | number:'1.0-0'}}%</div>
</div>
